import React from "react";
import { Typography } from "@mui/material";
import { getDocumentMeta } from "../../utils";
import s from "../MerchantDocumentUpload.module.scss";

const DocumentThumbnail = ({
  document,
  previewUrl,
  imageClassName = s.previewThumbnail,
  pdfClassName = s.previewPdf,
  placeholderClassName = s.previewPlaceholder,
  renderPdfAsObject = true,
}) => {
  const { extension, isImage, isPdf } = getDocumentMeta(document);
  const source = previewUrl || document?.url;

  if (isImage && source) {
    return (
      <img
        src={source}
        alt={document?.name}
        className={imageClassName}
      />
    );
  }

  if (isPdf && source) {
    if (renderPdfAsObject) {
      return (
        <object data={source} type="application/pdf" className={pdfClassName}>
          <div className={placeholderClassName}>
            <Typography variant="caption">PDF</Typography>
          </div>
        </object>
      );
    }
    return (
      <div className={placeholderClassName}>
        <Typography variant="caption">PDF</Typography>
      </div>
    );
  }

  return (
    <div className={placeholderClassName}>
      <Typography variant="caption">
        {extension?.toUpperCase() || "FILE"}
      </Typography>
    </div>
  );
};

export default DocumentThumbnail;
